import { render, staticRenderFns } from "./AccountAddress.vue?vue&type=template&id=78ad1c2c&scoped=true&"
import script from "./AccountAddress.vue?vue&type=script&lang=js&"
export * from "./AccountAddress.vue?vue&type=script&lang=js&"
import style0 from "./AccountAddress.vue?vue&type=style&index=0&id=78ad1c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad1c2c",
  null
  
)

export default component.exports